import { memo } from 'react'
import { DefaultButton, IStackStyles, Stack } from '@fluentui/react'

// const stackItemStyles: IStackItemStyles = {
//   root: {
//     flex: 1
//   },
// }

const stackStyes: IStackStyles = {
  root: {
    width: '100%'
  }
}

type EventModalFiltersProps = {
  handleNewEvent: () => void
}

const EventModalFilters = ({ handleNewEvent }: EventModalFiltersProps) => {

  // const handleTypeChange = () => { console.log('Change BE Type Filter') }

  const handleAddEventClick = () => { handleNewEvent() }

  return (
    <Stack tokens={{ padding: '24px 0px 0px' }} horizontal horizontalAlign='space-between'>
      <Stack styles={stackStyes} horizontal tokens={{ childrenGap: 16, maxWidth: 616 }}>
        {/* <Stack.Item grow styles={stackItemStyles} >
          <SearchBox placeholder='Search Events' />
        </Stack.Item>
        <Stack.Item styles={stackItemStyles}>  
          <Dropdown
            onChange={handleTypeChange}
            placeholder='All Types'
            multiSelect
            options={[
            {
              key: 'inPerson',
              text: 'In Person'
            },
            {
              key: 'webinar',
              text: 'Webinar'
            },
          ]}
          />
        </Stack.Item> */}
      </Stack>
      <DefaultButton onClick={handleAddEventClick}>Add New Event</DefaultButton>
    </Stack>
  )
}
export default memo(EventModalFilters)